export default __webpack_public_path__ + "static/media/Lozenge 1.181f388e.png";